
$(document).ready(function() {

  // MENU MOBILE
  $('.menu__nav').click(function () {
    $('header').toggleClass('opened');
    $('nav').toggleClass('opened');
    $('body').toggleClass('overflow');
    $('html').toggleClass('overflow');
  });
  $('.menu-item a').click(function (){
		$('header, nav').removeClass('opened');
    $('body, html').removeClass('overflow');
	});

  // SLIDESHOW CLIENTS LOGOS
  $('.slider__clients-logos').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });

  // SLIDESHOW CLIENTS TESTIMONIALS
  $('.slider__clients-testimonials').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    infinite: false,
  });

  // SLIDESHOW CASES CLIENTS TESTIMONIALS
  $('.slider__cases-clients-testimonials').slick({
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick'
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          infinite: false,
        }
      },
    ]
  }); 

  // SLIDESHOW SERVICES
  $('.slider__services').slick({
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick'
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  // SLIDESHOW CULTURE
  $('.slider__culture').slick({
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick'
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  // SLIDESHOW RATINGS
  $('.slider__ratings').slick({
    slidesToShow: 3,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        }
      }
      
    ]
  });

  // SLIDESHOW REASONS
  $('.slider__reasons').slick({
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick'
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        }
      }
      
    ]
  });

  // SLIDESHOW TESTIMONIALS
  $('.slider__testimonials').slick({
    dots: false,
    infinite: false,
    centerMode: true,
    slidesToShow: 3,
    infinite: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false, 
          variableWidth: false,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false, 
          variableWidth: false,
        }
      }
      
    ]
    
  });
  $('.slider__testimony').slick('slickGoTo', 1);

  // SLIDESHOW SOLUTIONS
  $('.slider__solutions').slick({
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick'
      },
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        }
      }
      
    ]
  });

  // FIXED HEADER
  if ( $(window).width() > 768 ) {
    $(window).scroll(function(){
      if ($(this).scrollTop() > 0) {
         $('#header').addClass('fixed');
         $('.sub-menu').css('display','none');
      } else {
         $('#header').removeClass('fixed');
      }
    });
  }

  // TABS
  if (location.hash.length > 1) {
    $('.tab__inner .tab__item').removeClass('current');
    $('.tab_content').removeClass('current');
    $('.tab__item[data-target="' + location.hash.replace('#', '') + '"]').addClass('current');
    $('.tab_content[data-target="' + location.hash.replace('#', '') + '"]').addClass('current');
    $(location.hash).addClass('current');
  }
  $('.tab__inner .tab__item').click(function () {
    var tab_id = $(this).attr('data-tab');
    $('.tab__inner .tab__item').removeClass('current');
    $('.tab_content, .tab_content.item').removeClass('current');
    $(this).addClass('current');
    $("#" + tab_id).addClass('current');
    if ( $(window).width() < 768 ) {
      $('.slider__cases-clients-testimonials').slick('refresh'); 
    }
  });
  $(".tab__inner .tab__item[data-tab='tab-all']").click(function () {
    $('.item').addClass('current');
  });

  // SMOOTH SCROLL
  $('.menu-item a, .scroll').click(function () {
    var target = $(this).attr('href').split('#').pop(); 
    $('html, body, index').animate({ scrollTop: jQuery('#' + target).offset().top }, 1000); 
    return false;
  });
  
});